<template>
  <div class="justify-content-center d-flex bg-white px-12 py-3 rounded" style="width: 328px; height: 98px;">
    <img src="/assets/images/cake.svg" />
    <div class="ms-3 d-flex flex-column justify-content-between">
      <div class="d-flex font-size-16 fw-semibold">
        <div>{{ title }}</div>
      </div>
      <div class="d-flex">
        <div class="text-blue400 fw-400 font-14">{{ description }}</div> 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatECard",
  props: ["href", "title", "description"],
};
</script>

<style scoped>
</style>